import { useEffect, useState } from "react";
import axios from 'axios';
import parse from 'html-react-parser';
import "./styles/scores.css";

function Scores({imageFrame, setImageFrame, settingCurrentPageForHeader}) {

    useEffect(()=> {
        settingCurrentPageForHeader("scores");
    }, [settingCurrentPageForHeader]);

    function imageFrameInit(src) {
        setImageFrame(true, src);
    }

    const [scoresState, setScoresState] = useState({
        scores : null,
        types : null,
        pageContent : null,
        status : false
    });

    useEffect(() => {
        axios.get('/api/scores.json')
        .then(function (response) {
            setScoresState({
                scores : response.data.scores,
                types : response.data.categories,
                pageContent : response.data.pageContent,
                status : true
            });
        })
        .catch(function (error) {
            setScoresState({
                scores : null,
                types : null,
                pageContent : <p className="text-center">Ups! Błąd aplikacji</p>,
                status : true
            });
        })
        .finally(function () {
            if(document.querySelector(".loading")) {
                document.querySelector(".loading").remove();
            }
        });
    }, []);

    function scoresCategory(data, id) {
        let scoresArray = [];
        data.map((item, index) => {
            if(item.category === id) {
                scoresArray.push(
                    <div className="composition" key={index}>
                        <h6>{parse(item.title)}</h6>
                        <div className="buttons">
                            <a href={scoresState.pageContent.filesPath + item.img} target="_blank" rel="noreferrer" onClick={(event) => {event.preventDefault();imageFrameInit(scoresState.pageContent.filesPath + item.img);}}>{scoresState.pageContent.previewText}</a>
                            <a href={scoresState.pageContent.filesPath + item.file} target="_blank" rel="noreferrer">{scoresState.pageContent.pdfButton}</a>
                        </div>
                    </div>
                );
            }
            return null;
        });
        return scoresArray;
    }

    function isEmpty(data, id) {
        let checkEmpty = true;
        data.map((item, index) => {
            if(item.category === id) {
                checkEmpty = false;
            }
            return null;
        });
        return checkEmpty;
    }

    useEffect(() => {
        // console.log(scoresState);
    }, [scoresState]);

    function scoresResult(data) {
        let scoresContent = [];
        if(data.status) {
            scoresState.types.map((item, index) => {
                scoresContent.push(
                    <div key={index} className={`scores-container${isEmpty(data.scores, item.id) ? " hide" : " visible"}`}>
                        <h3 className="scores-title">{item.name}</h3>
                        <div className="compositions-container">
                            {scoresCategory(data.scores, item.id)}
                        </div>
                    </div>
                );
                return null;
            });
        } else {
            scoresContent.push(data.ageContent);
        }
        return scoresContent;
    }

    return (
        <main>
            <div className="menu-space-container"></div>
            <div className="standard-padding">
                <div className="container">
                <div className="loading"><img src="/img/loader.png" alt="Wczytywanie..." /></div>
                {scoresResult(scoresState)}
                </div>
            </div>
        </main>
    );
}

export default Scores;
